import { Divider } from '@mui/material';

import { GDMDividerComponent } from './GDMDivider.type';

const GDMDivider: GDMDividerComponent = ({ ...props }) => <Divider {...props} />;

export default GDMDivider;
